import React, { useCallback, useRef } from "react";
import { Grid } from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useNavigate, useParams } from "react-router-dom";
import InvoiceTable from "../../components/invoice/InvoiceTable";
import { ClientForm } from "../../components/client/ClientForm";
import ReminderViewBox from "../../components/reminder/ReminderView";
import InvoiceModel, { InvoiceData } from "../../core/api/invoice/InvoiceModel";
import {
  RootContainer,
  GoBackFab,
  StyledPaper,
  ControlsContainer
} from "./styles/ClientViewStyles";
import PageRequest from "../../core/api/PageRequest";
import PageResponse from "../../core/api/PageResponse";
import { ClientControls } from "components/client/ClientControls";

export const ClientView: React.FC = () => {
  const { clientId = '' } = useParams();
  const invoiceTableRef = useRef<any>(null);
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleFetchInvoices = useCallback((page: PageRequest): Promise<PageResponse<InvoiceData>> => {
    return InvoiceModel.listClient(page, clientId);
  }, [clientId]);

  return (
    <RootContainer>
      <Grid container spacing={2}>
        <GoBackFab
          color="default"
          variant="circular"
          size="medium"
          onClick={handleGoBack}
          aria-label="go back"
        >
          <ArrowLeftIcon />
        </GoBackFab>

        {/* Client Form and Reminder Section */}
        <Grid container spacing={2} sx={{ mb: 2 }} style={{ width: '100%' }}>
          {/* Client Form Section */}
          <Grid
            size={{
              xs: 12,
              md: 9
            }}>
            <StyledPaper elevation={1}>
              <ClientForm clientId={clientId} />
            </StyledPaper>
          </Grid>

          {/* Reminder Section */}
          {clientId && (
            <Grid
              size={{
                xs: 12,
                md: 3
              }}>
              <StyledPaper elevation={1}>
                <ReminderViewBox clientId={clientId} />
              </StyledPaper>
            </Grid>
          )}
        </Grid>

        {/* Controls and Table Section */}
        {clientId && (<Grid container spacing={2} sx={{ mb: 2 }} style={{ width: '100%' }}>
                  {/* Table Section */}
          <Grid component="div"
          size={{
                xs: 12,
                md: 10
              }}>
              <InvoiceTable
                tableRef={invoiceTableRef}
                clientId={clientId}
                fetchFunction={handleFetchInvoices}
              />
          </Grid>
          {/* Controls Section */}
            {clientId && (
            <Grid component="div" size={{
              xs: 12,
              md: 2
            }}>
              <StyledPaper elevation={1}>
                <ControlsContainer>
                  <ClientControls clientId={clientId} tableRef={invoiceTableRef} />
                </ControlsContainer>
              </StyledPaper>
            </Grid>
          )}
        </Grid>
        )}
      </Grid>
    </RootContainer>
  );
};

export default ClientView;
